<template>
  <div>
    <div class="edit-wifi-modal">
      <div class="modal__container--header edit-wifi-modal__header">
        <div class="text">{{ header }}</div>
        <div class="close pointer">
          <span @click="close" class="mdi mdi-close"></span>
        </div>
      </div>
      <div class="edit-wifi-modal__container">
        <div class="edit-wifi-modal__container--row">
          <div class="row__input">
            <label for="name" class="inp">
              {{
                translate("device.config_dashboard.wifi_client.network_name")
              }}
              <!-- <span
                class="mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca; position: relative"
                @mouseover="text_assistant.name = true"
                @mouseleave="text_assistant.name = false"
              >
                <span
                  class="hide_text name"
                  :class="{ active: text_assistant.name }"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span> -->
              <input type="text" class="text" id="name" v-model="new_header" />
            </label>
          </div>
        </div>
        <div class="edit-wifi-modal__container--row">
          <div class="row__input" style="position: relative">
            <label for="ssid" class="inp">
              SSID
              <!-- <span
                class="mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca; position: relative"
                @mouseover="text_assistant.ssid = true"
                @mouseleave="text_assistant.ssid = false"
              >
                <span
                  class="hide_text ssid"
                  :class="{ active: text_assistant.ssid }"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span> -->
              <form id="ssid" method="post" autocomplete="off">
                <input
                  type="ssid"
                  id="inp1"
                  placeholder=" "
                  v-model="data.ssids"
                  :class="{
                    invalid: $v.data.ssids.$dirty && !$v.data.ssids.required,
                  }"
                />
                <small
                  class="red-text-12"
                  v-if="$v.data.ssids.$dirty && !$v.data.ssids.required"
                  >{{ translate("device.config_dashboard.empty_input") }}</small
                >
              </form>
            </label>
          </div>
          <div v-if="!isOpenNetwork" class="row__input">
            <label for="inp_password" class="inp" style="position: relative">
              {{ translate("device.config_dashboard.wifi_client.password") }}
              <!-- <span
                class="mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca; position: relative"
                @mouseover="text_assistant.password_encrypt = true"
                @mouseleave="text_assistant.password_encrypt = false"
              >
                <span
                  class="hide_text password_encrypt"
                  :class="{ active: text_assistant.password_encrypt }"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span> -->
              <span
                style="font-size: 18px"
                class="show-password mdi mdi-eye"
                :class="{ 'mdi-eye-off': isEyeClass }"
                @click="showHidePassword"
              ></span>
              <form id="password" method="post" autocomplete="off">
                <input
                  type="password"
                  id="inp_password"
                  placeholder=" "
                  v-model="data.pass"
                  :class="{
                    invalid: $v.data.pass.$dirty && !$v.data.pass.required,
                  }"
                />
                <small
                  class="red-text-12"
                  v-if="$v.data.pass.$dirty && !$v.data.pass.required"
                  >{{ translate("device.config_dashboard.empty_input") }}</small
                >
                <small
                  class="red-text-12"
                  v-if="$v.data.pass.$dirty && !$v.data.pass.minLength"
                  >{{ translate("device.config_dashboard.min_length") }}</small
                >
              </form>
            </label>
          </div>
        </div>
        <div
          class="edit-wifi-modal__container--row"
          style="align-items: flex-end"
        >
          <div class="row__input">
            <label>
              {{
                translate("device.config_dashboard.wifi_client.wan_interfaces")
              }}
              <!-- <span
                class="mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca; position: relative"
                @mouseover="text_assistant.wan_interfaces = true"
                @mouseleave="text_assistant.wan_interfaces = false"
              >
                <span
                  class="hide_text wan_interfaces"
                  :class="{ active: text_assistant.wan_interfaces }"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span> -->
            </label>
            <multiselect
              class="multiselect_test"
              :options="data.wan_ifaces_all"
              v-model="data.wan_ifaces"
              :multiple="true"
              :clear-on-select="false"
              :placeholder="''"
              :selectLabel="''"
              :selectedLabel="''"
              :deselectLabel="''"
              :searchable="false"
            />
          </div>
          <div style="margin-right: 60px">
            <label class="switch">
              {{
                translate("device.config_dashboard.wifi_client.open_network")
              }}
              <!-- <span
                class="mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca; position: relative"
                @mouseover="text_assistant.open_network = true"
                @mouseleave="text_assistant.open_network = false"
              >
                <span
                  class="hide_text open_network"
                  :class="{ active: text_assistant.open_network }"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span> -->
              <input v-model="isOpenNetwork" type="checkbox" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
      </div>
      <div class="edit-wifi-modal__buttons">
        <span>
          <span @click="deleteWifiClient" class="btn btn-danger">
            {{ translate("btn.delete") }}
          </span>
        </span>
        <span>
          <span
            @click="close"
            style="margin-right: 10px"
            class="notice-btn btn-success btn btn-info"
          >
            {{ translate("btn.cancel") }}
          </span>
          <span @click="save" class="btn btn-success">
            {{ translate("btn.edit") }}
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import Multiselect from "vue-multiselect";
import { validationMixin } from "vuelidate";
import { required, minLength, requiredIf } from "vuelidate/lib/validators";

export default Vue.extend({
  name: "WifiClientModal",
  mixins: [validationMixin],
  components: {
    Multiselect,
  },
  props: {
    dataWifiClient: Object,
    header: String,
  },
  data: function () {
    return {
      old_name: '',
      old_ssid: '',
      isEyeClass: false,
      newData: {},
      new_header: "",
      data: {},
      radioWanLan: "lan",
      radioIpv4: "manual",
      isOpenNetwork: false,
      text_assistant: {
        name: false,
        mac_address: false,
        access_point: false,
        client: false,
        disable: false,
        ssid: false,
        password_encrypt: false,
        password: false,
        disabled_encrypt: false,
        frequency: false,
        channel: false,
        lan: false,
        max_users: false,
        hide_network: false,
        wan_interfaces: false,
        open_network: false,
      },
    };
  },
  validations() {
    return {
      data: {
        ssids: {
          required,
        },
        pass: {
          required: requiredIf(function () {
            return (
              this.isOpenNetwork == false
            );
          }),
          minLength: minLength(8),
        },
      },
    };
  },
  methods: {
    save() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      } else {
        this.newData[this.new_header] = {
          default_route: this.dataWifiClient.default_route || "",
          ssids: this.data.ssids,
          pass: this.data.pass,
          wan_ifaces: this.data.wan_ifaces,
          old_name: this.old_name,
          old_ssid: this.old_ssid
        };
        if (this.isOpenNetwork === true) {
          delete this.newData[this.new_header].pass
        }
        //console.log(this.newData)
        this.$emit("update", this.newData);
        this.$emit("close");
      }
    },
    deleteWifiClient() {
      this.$emit("delete", this.header);
      this.close();
    },
    showHidePassword: function () {
      const input = document.getElementById("inp_password");
      if (input === null) return false;
      if (input.getAttribute("type") == "password") {
        this.isEyeClass = true;
        input.setAttribute("type", "text");
      } else {
        this.isEyeClass = false;
        input.setAttribute("type", "password");
      }
      return false;
    },
    close() {
      this.$emit("close");
    },
  },
  created() {
    this.new_header = this.header;
    this.data = {
      ssids: this.dataWifiClient.ssids || "",
      led: this.dataWifiClient.led || "",
      pass: this.dataWifiClient.pass || "",
      default_route: this.dataWifiClient.default_route || "",
      wan_ifaces: this.dataWifiClient.wan_ifaces || [],
      wan_ifaces_all: this.dataWifiClient.wan_ifaces_all || [],
    };
    this.old_name = this.header;
    this.old_ssid = this.data.ssids;
  },
});
</script>

 <style src="assets/sass/radio-button.scss" lang="scss" scoped></style>
<style src="assets/sass/slider-round.scss" lang="scss" scoped></style>
<style src="assets/sass/show-hide-password.scss" lang="scss" scoped></style>

<style lang="scss" scoped>
.edit-wifi-modal {
  max-width: 600px;
  padding: 0;

  &__header {
    color: #66615b;
    font-size: 18px;
    padding: 26px 24px;
    border-bottom: 1px solid #cecfd1;
    display: flex;
    justify-content: space-between;
  }

  &__container {
    padding: 8px 24px;
    overflow-y: scroll;
    &--row {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin: 20px 0;
      label {
        margin-bottom: 0;
      }
      .row__label {
        color: gray;
        font-size: 13px;
        display: flex;
        margin-right: 24px;
      }
      .row__input {
        max-width: 268px;
        width: 100%;
        label {
          width: 100%;
        }
        span {
          color: #c3c7ca;
          font-size: 13px;
          font-weight: bold;
        }
        input {
          width: 100%;
          border: none;
          outline: none;
          padding: 0;
          height: 33px;
          font-size: 14px;
          font-weight: 400;
          background: none;
          border-radius: 0;
          color: #66615b !important;
          transition: all 0.4s ease;
          border-bottom: 1px solid #515459;
          background-color: transparent !important;
          font-family: Roboto, sans-serif;
          caret-color: #c3c7ca;
        }
      }
    }
    &--line {
      border-bottom: 1px solid gray;
      margin: 5px 0;
    }
  }

  &__buttons {
    border-top: 1px solid gray;
    padding: 24px;
    display: flex;
    justify-content: space-between;
  }
}

.vue-select {
  .vs__dropdown-toggle {
    border: none !important;
    border-bottom: 1px solid #515459 !important;
    color: #c3c7ca;
    background: none;
  }
  input {
    color: #c3c7ca;
    padding: 0;
  }
}

.scanning {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(10px, 22px);
  padding: 7px 10px;
  color: white;
  border: none;
  background-color: #00a254;
}

@media (max-width: 600px) {
  .edit-wifi-modal {
    &__container {
      max-height: 400px;
      &--row {
        .row__input {
          max-width: 150px;
          &--3blocks {
            max-width: 100px !important;
          }
        }
      }
    }
  }
}

.hide_text {
  width: 300px;
  position: absolute;
  bottom: -43px;
  left: 85px;
  white-space: normal;
  background: #f9f9f9;
  padding: 10px;
  border-radius: 5px;
  transition: 0.2s;
  box-shadow: 1px 1px 5px #202020;
  opacity: 0;
  z-index: -1;
  &.name {
    bottom: -76px;
    left: 9px;
    //transform: translateX(200px);
  }
  &.mac_address {
    bottom: -75px;
    left: -289px;
    //transform: translateX(-200px);
  }
  &.access_point {
    bottom: 22px;
    left: 10px;
    color: #c3c7ca;
    font-size: 13px;
    font-weight: bold;
    //transform: translateX(-200px);
  }
  &.client {
    bottom: 22px;
    left: 10px;
    color: #c3c7ca;
    font-size: 13px;
    font-weight: bold;
    //transform: translateX(-200px);
  }
  &.disable {
    bottom: 22px;
    left: -289px;
    color: #c3c7ca;
    font-size: 13px;
    font-weight: bold;
  }
  &.ssid {
    bottom: -75px;
    left: 10px;
  }
  &.ip_address {
    bottom: 22px;
    left: 10px;
  }
  &.mask {
    bottom: 22px;
    left: 10px;
  }
  &.gateway {
    bottom: 22px;
    left: -293px;
  }
  &.interfaces {
    bottom: 22px;
    left: 10px;
  }
  &.usage_policy {
    bottom: 22px;
    left: 10px;
    color: #c3c7ca;
    font-size: 13px;
    font-weight: bold;
  }
  &.mtu {
    bottom: 22px;
    left: 10px;
  }
  &.password_encrypt {
    bottom: 22px;
    left: -293px;
  }
  &.password {
    bottom: 22px;
    left: -293px;
  }
  &.disabled_encrypt {
    bottom: 22px;
    left: 10px;
    color: #c3c7ca;
    font-size: 13px;
    font-weight: bold;
  }
  &.frequency {
    bottom: 22px;
    left: 10px;
  }
  &.channel {
    bottom: 22px;
    left: -293px;
  }
  &.lan {
    bottom: 22px;
    left: 10px;
  }
  &.max_users {
    bottom: 22px;
    left: -293px;
  }
  &.hide_network {
    bottom: 22px;
    left: 10px;
    color: #c3c7ca;
    font-size: 13px;
    font-weight: bold;
  }
  &.wan_interfaces {
    bottom: 22px;
    left: 10px;
    color: #c3c7ca;
    font-size: 13px;
    font-weight: bold;
  }
  &.open_network {
    bottom: 22px;
    left: -293px;
    color: #c3c7ca;
    font-size: 13px;
    font-weight: bold;
  }
  &.active {
    opacity: 1;
    z-index: 1;
    transform: translate(0, 0);
  }
}
</style>